import { useState } from 'react'

interface ImageWithFallbackProps {
  src: string
  alt: string
  fallbackUrl: string
  style?: React.CSSProperties
  className?: string
}

export function ImageWithFallback({
  src,
  alt,
  fallbackUrl,
  style,
  className,
}: ImageWithFallbackProps) {
  const [imgError, setImgError] = useState(false)

  return (
    <>
      {!imgError || !fallbackUrl ? (
        <img
          src={src}
          alt={alt}
          onError={() => setImgError(true)}
          style={style}
          className={className}
        />
      ) : (
        <img src={fallbackUrl} alt={alt} style={style} className={className} />
      )}
    </>
  )
}
